import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAsyncAction } from '../hooks/useAsyncAction';
import AuthCard from '../components/AuthCard';
import PasswordInput from '../components/PasswordInput';
import { authStyles } from '../styles/authStyles';

export default function ResetPasswordPage() {
  const { resetPassword } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const { loading, error, setError, run } = useAsyncAction();

  if (!token) {
    return (
      <AuthCard>
        <h1 style={authStyles.heading}>Invalid link</h1>
        <p style={authStyles.sub}>This password reset link is missing or malformed.</p>
        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <Link to="/forgot-password" style={authStyles.link}>Request a new reset link</Link>
        </div>
      </AuthCard>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    await run(async () => {
      await resetPassword(token, password);
      navigate('/login', { state: { flash: 'Password updated. You can now log in.' } });
    });
  };

  return (
    <AuthCard>
      <h1 style={authStyles.heading}>Set new password</h1>
      <p style={authStyles.sub}>Choose a new password for your account.</p>

      {error && <div style={authStyles.error}>{error}</div>}

      <form onSubmit={handleSubmit} style={authStyles.form}>
        <label style={authStyles.label}>
          New password
          <PasswordInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
            autoFocus
            minLength={8}
          />
        </label>
        <p style={styles.hint}>At least 8 characters.</p>
        <button type="submit" disabled={loading} style={authStyles.button}>
          {loading ? 'Updating…' : 'Update password'}
        </button>
      </form>
    </AuthCard>
  );
}

const styles = {
  hint: {
    fontSize: '12px',
    color: '#9ca3af',
    margin: '-8px 0 0',
  },
};
